/*
 * Public API Surface of angular-resizable-element
 */

export * from './lib/resizable.module';
export { BoundingRectangle } from './lib/interfaces/bounding-rectangle.interface';
export { Edges } from './lib/interfaces/edges.interface';
export { ResizeEvent } from './lib/interfaces/resize-event.interface';
export { ResizableDirective, ResizeCursors } from './lib/resizable.directive';
export { ResizeHandleDirective } from './lib/resize-handle.directive';
